import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../lib/analytics'

// Fires a GA4 page_view on every SPA route change. Mounted once in
// TrackingShell (App.jsx). All consent gating lives in analytics.js —
// this just reacts to navigation. No-op when GA isn't configured.
export function useGaPageview() {
  const location = useLocation()
  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location.pathname, location.search])
}
